import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Core2Config} from '../../shared/core2Config';
import { ApiResponseModel, ApiVisa } from '../../shared';
import { Observable } from 'rxjs';
import { BaseApiPublicLoginTemplateService } from '../../shared/base-api-public-login-template.service';
import { LabelCrmLinkContainerModel } from "../../../../../../models/aggregates/crm/label";


@Injectable({
  providedIn: 'root'
})
export class CrmLabelLinkService extends BaseApiPublicLoginTemplateService<LabelCrmLinkContainerModel, LabelCrmLinkContainerModel, LabelCrmLinkContainerModel> {

  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_CRM_MODULE_URL_PREFIX + 'label-links';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_CRM_MODULE_URL_PREFIX + 'label-links';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_CRM_MODULE_URL_PREFIX + 'label-links';
    this.endpoint_path_login_url = Core2Config.TENANT_DOMAIN_CRM_MODULE_URL_PREFIX + 'label-links/login-ep';
    this.httpClient = http;
  }

  postMultiMembers(dtoObject: any, visa: ApiVisa): Observable<ApiResponseModel<any>> {
    let customUrl;
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
      customUrl = this.apiUrl + "/backoffice-ep/add-multi-member";
    }
    return this.httpClient.post<ApiResponseModel<any>>(
      customUrl,
      dtoObject,
      this.getHttpHeader(visa)
    );
  }

  postMultiLabels(dtoObject: any, visa: ApiVisa): Observable<ApiResponseModel<any>> {
    let customUrl;
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
      customUrl = this.apiUrl + "/backoffice-ep/add-multi-label";
    }
    return this.httpClient.post<ApiResponseModel<any>>(
      customUrl,
      dtoObject,
      this.getHttpHeader(visa)
    );
  }

  deleteMultiMembers(dtoObject: any, visa: ApiVisa): Observable<ApiResponseModel<any>> {
    let customUrl;
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
      customUrl = this.apiUrl + "/backoffice-ep/delete-multi-member";
    }
    return this.httpClient.post<ApiResponseModel<any>>(
      customUrl,
      dtoObject,
      this.getHttpHeader(visa)
    );
  }
}
